<template>
  <div class="share">
    <el-form-item label="分享图：" class="width100">
      <moreImageUpload v-model="form.shareData.imgs" :limit="9" hintText="建议尺寸750x750像素以上" />
    </el-form-item>
    <el-form-item label="分享文案：" class="width100">
      <el-link type="primary" @click="formShareVisible = true">添加文案</el-link><br />
      <div v-for="(item,index) in form.shareData.content" :key="index"><el-tag size="medium" closable effect="dark" @close="deleteShareWX(index)">{{index + 1}}、{{item}}</el-tag></div>
    </el-form-item>
    <el-dialog title="添加文案" :visible.sync="formShareVisible" :modal="false" width="600px" :close-on-click-modal="false">
      <el-form label-position="right" size="small" label-width="100px">
        <el-form-item label="分享文案" prop="name">
          <div class="flexs" v-for="(item,index) in shareData" :key="index">
            <el-input v-model="item.value" placeholder="请输入分享文案" />
            <el-button type="primary" @click="addShare">添加</el-button>
            <el-button type="danger" @click="deleteShare(index)">删除</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formShareVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doShareCreate()">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MoreImageUpload from "@/components/MoreImageUpload";
import sysGoodsShareApi from '@/api/goods/sysGoodsShare'
export default {
  props: ['form'],
  components: { MoreImageUpload },
  data() {
    return {
      formShareVisible: false,
      shareData: [{ value: '' }]
    }
  },
  created() {
    this.getShareData()
  },
  methods: {
    getShareData() {
      sysGoodsShareApi.fetchShareData({ sysGoodsId: this.form.id }).then(({ data }) => {
        if (data.length > 0) {
          let { imgs, content } = data[0]
          this.$set(this.form, 'shareData', { imgs: JSON.parse(imgs), content: JSON.parse(content) });
        } else {
          this.$set(this.form, 'shareData', { imgs: [], content: [] });
        }
      })
    },
    doShareCreate() {
      let arr = []
      this.shareData.forEach(item => {
        if (item.value) arr.push(item.value)
      })
      this.form.shareData.content = arr;
      this.formShareVisible = false
    },
    deleteShare(index) {
      this.shareData.splice(index, 1)
    },
    addShare() {
      this.shareData.push({ value: '' })
    },
    deleteShareWX(index) {
      this.form.shareData.content.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.flexs {
  display: flex;
  margin-right: 10px;
  margin-bottom: 5px;
  .el-input {
    margin-right: 10px;
  }
}
</style>